__turbopack_context__.v({
  "currency": "input-module-scss-module__YQiWqa__currency",
  "disabled": "input-module-scss-module__YQiWqa__disabled",
  "inner": "input-module-scss-module__YQiWqa__inner",
  "isError": "input-module-scss-module__YQiWqa__isError",
  "isFull": "input-module-scss-module__YQiWqa__isFull",
  "large": "input-module-scss-module__YQiWqa__large",
  "medium": "input-module-scss-module__YQiWqa__medium",
  "normal": "input-module-scss-module__YQiWqa__normal",
  "number": "input-module-scss-module__YQiWqa__number",
  "search": "input-module-scss-module__YQiWqa__search",
  "small": "input-module-scss-module__YQiWqa__small",
  "visual": "input-module-scss-module__YQiWqa__visual",
  "wrapper": "input-module-scss-module__YQiWqa__wrapper",
});
